import { Box, Divider, useColorModeValue } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'
import {
  HowItWorksSection,
  NotableDiscoveriesSection,
  ResearchToolsSection,
  CommunitySection,
  OptimizedHeroSection,
  FeaturesSection as OptimizedFeaturesSection,
} from '../components/home'
import { Icon, Flex, Text } from '@chakra-ui/react'
import { MapPin, Compass, Scroll } from '@phosphor-icons/react'

// Define animations
const pageTurn = keyframes`
  0% { transform: translateY(25px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

// Simple Icon Divider Component for Home Page
const HomePageDivider = () => {
  const iconColor = useColorModeValue('interactive.primary', 'interactive.primary');
  const dividerColor = useColorModeValue('border.default', 'border.default');
  
  return (
    <Box position="relative" my={{ base: 6, md: 8 }}>
      <Flex align="center" justify="center">
        <Icon as={MapPin} boxSize={5} color={iconColor} opacity={0.7} />
        <Box w="60px" h="1px" bg={dividerColor} mx={3} opacity={0.5} />
        <Icon as={Compass} boxSize={6} color={iconColor} opacity={0.8} />
        <Box w="60px" h="1px" bg={dividerColor} mx={3} opacity={0.5} />
        <Icon as={Scroll} boxSize={5} color={iconColor} opacity={0.7} />
      </Flex>
    </Box>
  );
};

export default function Home() {
  return (
    <Box 
      position="relative" 
      overflowX="hidden"
      bg={useColorModeValue('bg.default', 'bg.default')}
      sx={{ zoom: 0.9 }}
    >
      {/* Main Content with enhanced layout */}
      <Box
        position="relative"
        zIndex={1}
      >
        <OptimizedHeroSection />
        
        <HomePageDivider />
        
        <Box position="relative">
          <OptimizedFeaturesSection />
        </Box>
        
        <HomePageDivider />
        
        <Box position="relative">
          <HowItWorksSection />
        </Box>
        
        <HomePageDivider />
        
        <Box position="relative">
          <NotableDiscoveriesSection />
        </Box>
        
        <HomePageDivider />
        
        <Box position="relative">
          <ResearchToolsSection />
        </Box>
        
        <HomePageDivider />
        
        <Box position="relative">
          <CommunitySection />
        </Box>

        {/* Bottom Decorative Element */}
        <Box
          py={{ base: 4, md: 6 }}
          textAlign="center"
          position="relative"
        >
          <Flex align="center" justify="center" opacity={0.5}>
            <Icon as={MapPin} boxSize={4} color={useColorModeValue('interactive.primary', 'interactive.primary')} />
            <Box w="100px" h="1px" bg={useColorModeValue('border.default', 'border.default')} mx={4} />
            <Text fontFamily="handwritten" fontSize="sm" color={useColorModeValue('text.muted', 'text.muted')}>
              End of Volume I
            </Text>
            <Box w="100px" h="1px" bg={useColorModeValue('border.default', 'border.default')} mx={4} />
            <Icon as={Compass} boxSize={4} color={useColorModeValue('interactive.primary', 'interactive.primary')} />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}
